<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="750px" @close="close">
    <div slot="content">
      <el-form :model="formData" ref="formData">
        <el-row style="padding-bottom: 10px;">
          <span style="font-size: 16px;">엑셀 파일 등록</span>
          <span style="color: #47C7B8; padding-left: 25px;">(파일의 내용이 템플릿에 맞지 않는 경우, 정보가 정상적으로 등록되지 않습니다.)</span>
        </el-row>
        <el-input disabled style="width: 85%; float: left; margin-right: 5px;" v-model="fileList.name"></el-input>
        <el-upload action="" :auto-upload="false" :show-file-list="false" accept :on-change="changeUploadFile">
          <el-button type="primary" size="medium" style="margin-right: 5px; width: 100%;">파일업로드</el-button>
        </el-upload>
        <el-row style="padding-top: 5px;">
          <el-button size="mini" type="solid" @click="onDownloadExcelTemlate"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">엑셀 템플릿 다운로드</el-button>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="btn-group-right">
      <el-button size="large" type="primary" @click="onClickExcelImport" :disabled="!saveButtonDisabled">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import fileApi from '@/api/common/file';

export default {
  name: 'WTriggerVarValueExcelImportPopup',
  props: {
    selectedTrigger: {
      type: Object,
    },
  },
  data() {
    return {
      fileList: {},
      saveButtonDisabled: false,
      formData: {},
    };
  },
  computed: {
    popupTitle() {
      return isNil(this.selectedTrigger) ? EMPTY_TEXT : `[${this.selectedTrigger.triggerName}] 변수 값 엑셀입력`;
    },
  },
  methods: {
    open() {
      this.fileList = {};
      this.saveButtonDisabled = false;
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    changeUploadFile(item) {
      this.fileList = item.raw;
      this.saveButtonDisabled = true;
    },
    /**
     * 엑셀 템플릿을 이용한 템플릿 변수 입력
     * @author jeee12
     * @return {[type]} [description]
     */
    onClickExcelImport() {
      const data = new FormData();
      data.append('triggerId', this.selectedTrigger.triggerId);
      if (this.fileList.uid) {
        data.append('files', this.fileList);
      }
      amsSettingsApi.importTrgNodeVarValueByExcel(data).then((response) => {
        if (response.data.success) {
          this.$emit('re-load');
          this.close();
          this.$message(msgUtil.getCustomResultMsgData('엑셀 입력이 완료되었습니다.', true));
        } else {
          this.$message(msgUtil.getCustomResultMsgData(`${response.data.message}`, false));
        }
      }).catch(() => {});
    },
    /**
     * 템플릿 변수 입력을 위한 엑셀 템플릿 다운로드
     * @author jeee12
     * @return {[type]} [description]
     */
    onDownloadExcelTemlate() {
      const message = '엑셀 템플릿을 다운로드하시겠습니까?';
      this.$confirm(...msgUtil.getCustomConfirmData(message)).then(() => {
        amsSettingsApi.exportTrgNodeVarValueList({
          triggerId: this.selectedTrigger.triggerId,
          triggerName: this.selectedTrigger.triggerName,
        }).then((response) => {
          if (response.data.success && response.data.data) {
            fileApi.downloadExportedExcelFile(response.data.data);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/popup/TriggerVarValueExcelImportPopup.vue